
import { ContactAndSchedule } from './ContactAndSchedule';
import ContactForm from './ContactForm';

function NeedHelp() {

    return <>
      <div className="h-auto bg-[#F3F3F3] text-[#101010] w-full flex justify-center">
        <div className="w-[80%] flex flex-col justify-between p-4">
            <p className="text-[#4CB117] font-extrabold text-2xl text-left py-3">Need help? Our team is always here to assist you</p>
            <div className="w-full flex flex-col md:flex-row">
                <div className="w-full md:w-[60%] text-left flex flex-col pr-6">
                    
                    <p className='text-sm'>Don’t hesitate to reach out with the contact information below, or send a message using the form.</p>
                    
                    <ContactForm />
                  
                </div>
                <hr className='my-3 md:hidden'/>
                <div className="w-full md:w-[40%] flex flex-col items-start text-left">
                    <ContactAndSchedule />
                </div>
            </div>
        </div>
      </div>
    </>;
  }


  
  export default NeedHelp;